/**  
 * created by panjm on 2019-10-25
 * 
 * description： 我提交的审批相关接口地址配置
 * 
 */

const config = require('libs/config.js');

const mine = {
	// 表格数据接口地址
	getList: config.MS_SP_PATH + '/v1/operate/submit/list',
};

export default mine;



// WEBPACK FOOTER //
// ./src/api/mine/index.js